<template>
<div class="modal">
  <!--input id="modal_trigger" type="checkbox" />
  <label for="modal_trigger">1</label-->
  <div class="modal_overlay" :class="{ showfiche: mesures.length>0}">
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="modal_header_title">
          <p>{{ $t("message['Informations disponibles']")}}</p>
          <label for="modal_trigger" @click="close" class="close_modal"></label>
        </div>
        <hr />
      </div>
      <div class="modal_tabs">
        <button id="tab_mesures" v-if="mesures.length>1" @click="changeModalTabs" class="modal_tab tab_supports_et_mesures active">{{ $tc("message['Mesure']",2)}}</button>
        <button id="tab_mesure" @click="changeModalTabs" class="modal_tab tab_support hidetab">{{ $tc("message['Mesure']")}} {{mesure.numero}}</button>
      </div>
      <div class="modal_all_content">
        <!-- Contenu SUPPORTS ET MESURES  -->
        <div id="mesures_modal" v-if="mesures.length>1" class="modal_content modal_content_supports_et_mesures active">
          <p class="modal_subtitle">{{mesures.length}} {{ $t("message['mesures trouvées']")}}</p>
          <div class="modal_list_tab">
            <div class="modal_list_item" v-for="(mesure, index) in mesures" :key="index">
              <p class="link" @click="changeModalTabsFromId(mesure)">{{mesure.numero}}</p>
              <p>{{mesure.date}}</p>
              <p>{{mesure.adresse.numero}} {{mesure.adresse.voie}}
                <br />{{mesure.adresse.codepostal}} {{mesure.adresse.commune}}</p>
            </div>
          </div>
          <div class="conditions">
            <p class="conditions_title">Edition {{ $t("message['du']")}} {{date}}</p>
            <p class="conditions_subtitle">{{ $t("message['Pour une meilleure compréhension de cette fiche, consultez le']")}}
              <a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a> {{ $t("message['et la']")}}
              <a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a>.
              <br />
              <span v-if="$root.$i18n.locale === 'en'">In case of error, please.<a href="http://faq.anfr.fr/" target="_blank" class="link"> contact us</a></span>
              <span v-else><a href="http://faq.anfr.fr/" target="_blank" class="link">Nous contacter</a> en cas d'erreur </span></p>
            <p v-if ="mesure.typedemande != 6" class="conditions_text">{{ $t("message['Ces informations relatives etc.']")}}.</p>
            <p v-if ="mesure.typedemande == 6" class="conditions_text">Les informations relatives aux caractéristiques radioélectriques des objets communicants sont mises à disposition du public conformément à la mission de l’ANFR d’assurer le respect des valeurs limites d'exposition du public aux champs électromagnétiques prévue par le cinquième alinéa de l’article L. 43 du code des postes et des communications électroniques. La vérification du respect des valeurs limites est assurée par des organismes accrédités selon des modalités prévues par l’article L. 34-9-1 et D. 100 du code des postes et des communications électroniques.</p>
            <p v-if ="mesure.typedemande == 5" class="conditions_text">Les informations relatives aux caractéristiques radioélectriques des objets communicants sont mises à disposition du public conformément à la mission de l’ANFR d’assurer le respect des valeurs limites d'exposition du public aux champs électromagnétiques prévue par le cinquième alinéa de l’article L. 43 du code des postes et des communications électroniques. La vérification du respect des valeurs limites est assurée par des organismes accrédités selon des modalités prévues par l’article L. 34-9-1 et D. 100 du code des postes et des communications électroniques.</p>
          </div>
        </div>
        <!-- Contenu Mesure  -->
        <div id="mesure_modal" class="modal_content modal_content_support">
          <p class="modal_subtitle">{{ $t("message['Fiche mesure']")}} N° {{mesure.numero}} - {{ $t("message['Synthèse']")}}</p>
          <div class="support_detail">
            <p><span>{{ $t("message['Mesure réalisée le']")}} : </span> {{mesure.date}}<span v-if="mesure.heure">{{" à : "}}</span>{{mesure.heure}}</p>
            <p><span>{{ $t("message['Par le laboratoire']")}} : </span> {{mesure.laboratoire}}</p>
            <p><span>{{ $t("message['Localisation du point de mesure']")}} : </span> {{adresse.numero}} {{adresse.voie}} {{adresse.codepostal}} {{adresse.commune}}</p>
            <p><span>{{ $t("message['Mesure effectuée']")}} : </span> à l'{{mesure.milieu}}</p>
            <p><span>{{ $t("message['Environnement']")}} : </span> {{mesure.environnement}}</p>

          </div>
          <div class="img_subtitle">{{ $t("message['Mesure effectuée']")}} {{ $t("message['suivant le protocole']")}} {{mesure.protocole}} ({{ $t("message['présentation du protocole']") }}
            <a target="_blank" :href="$store.state.params.protocolUrl">{{ $t("message['ici']") }}</a>).</div>
          <hr>
          <div v-if="mesure.typedemande == 5 || mesure.typedemande == 6" class="modal_subtitle">{{ $t("message['Positionnement de l objet communicant fixe']") }}</div>
          <div v-else class="modal_subtitle">{{ $t("message['Positionnement des émetteurs visibles du point de mesure']") }}</div>
          <div class="list_subtitle">
            <p>Hp ({{ $t("message['hauteur du point de mesure']") }}) : {{mesure.hauteur}}m</p>
          </div>
          <div v-if="emetteurs" class="emetteur_visible">
            <div v-if="mesure.typedemande != 5 && mesure.typedemande != 6" class=figure>
              <p><img class=scaled :src="`/static/img/mesures/emetteur_visible.png`"></p>
              <p>({{ $t("message['schéma type : dans certains cas, Hp est supérieur ou égal à He']") }})</p>
            </div>
            <div class="modal_list_tab">
              <div class="modal_list_item">
                <div class="modal_list_item_content">
                  <span v-if="mesure.typedemande != 5 && mesure.typedemande != 6">{{ $t("message['Emetteurs visibles du point de mesure']") }}</span>
                  <span v-else>{{ $t("message['Objet communicant']") }}</span>
                </div>
                <div class="modal_list_item_content">
                  <span v-if="mesure.typedemande != 5 && mesure.typedemande != 6">He ({{ $t("message['Hauteur de l émetteur']") }})</span>
                  <span v-else> {{ $t("message['Hauteur de l objet communicant fixe']") }}</span>
                </div>
                <div class="modal_list_item_content">
                  <span v-if="mesure.typedemande != 5 && mesure.typedemande != 6">d ({{ $t("message['Distance point de mesure/émetteur']") }})</span>
                  <span v-else>{{ $t("message['Distance point de mesure/objet communicant fixe']") }}</span>
                </div>
              </div>
              <div class="modal_list_item" v-for="(emetteur, index) in emetteurs" :key="index">
                <div class="modal_list_item_content">
                  <p>{{emetteur.libelle}}</p>
                </div>
                <div class="modal_list_item_content">
                  <p>{{emetteur.hauteur}} m</p>
                </div>
                <div class="modal_list_item_content">
                  <p>{{emetteur.distance}} m</p>
                </div>
              </div>
            </div>
          </div>
          <div class="img_subtitle" v-else>
            <p>{{ $t("message['Aucun émetteur visible depuis le point de mesure']") }}.</p>
          </div>
          <div class="modal_subtitle">
            <p>{{ $t("message['Conclusion du rapport de mesure']") }}</p>
          </div>
          <div class="conformite_text" v-if="mesure.conformite === 'true'">{{ $t("message['Le rapport de mesure conclut au respect des valeurs limites d exposition fixées par le décret du 3 mai 2002']") }}.</div>
          <div class="conformite_text" v-else>{{ $t("message['Le rapport conclut à la non-conformité des valeurs limites d exposition fixées par le decret du 3 mai 2002']") }}.</div>
          <div  class="modal_subtitle">
            <p v-if="mesure.typedemande != 5 && mesure.typedemande != 6">{{ $t("message['Résultat de l évaluation globale de l exposition (cas A du protocole)']") }}</p>
            <p v-if="mesure.typedemande == 6">{{ $t("message['Résultat de l évaluation de l exposition de l objet communicant fixe (cas 9 kHz-100 kHz)']") }}</p>
            <p v-if="mesure.typedemande == 5">{{ $t("message['Résultat de l évaluation de l exposition de l objet communicant fixe (cas B du protocole)']") }}</p>
          </div>
          <div class="conditions_subtitle">
            <p v-if="mesure.typedemande != 5 && mesure.typedemande != 6">{{ $t("message['Le niveau global d exposition est le résultat de la mesure des champs éléctromagnétiques émis globalement par l ensemble des émetteurs environnant le point de mesure, visibles ou non, qui sont en fonctionnement au moment de la mesure']") }}.</p>
            <p v-if="mesure.typedemande == 6">{{ $t("message['Conformément au souhait du demandeur, une évaluation de l exposition de l objet communicant fixe a été réalisée. Les champs maximaux électriques (E) et magnétiques (H) ont été mesurés, ainsi que les champs moyens à titre informatif.']") }}</p>
            <p v-if="mesure.typedemande == 5">{{ $t("message['Conformément au souhait du demandeur, une évaluation de l exposition de l objet communicant fixe a été réalisée. Le champ moyen électrique (E) a été mesuré, ainsi que le champ maximal à titre informatif.']") }}</p>
          </div>
          <div v-if="mesure.typedemande != 5 && mesure.typedemande != 6" class="conformite_text">{{ $t("message['Niveau global d exposition']") }} : {{mesure.mesureglobale}} V/m</div>
          <div v-if="mesure.typedemande == 5 || mesure.typedemande == 6" class="modal_list_tab">
            <div class="modal_list_item">
              <div class="modal_list_item_content">
                <span >Service</span>
              </div>
              <div class="modal_list_item_content">
                <span >{{ $tc("message['Bande de fréquence']")}} (MHz)</span>
              </div>
              <div class="modal_list_item_content">
                <span>{{ $tc("message['Mesure']") }} E {{ $t("message['moy']") }}(V/m)</span>
              </div>
              <div v-if="mesure.typedemande == 6" class="modal_list_item_content">
                <span>{{ $tc("message['Mesure']") }} H {{ $t("message['moy']") }}(<nobr class="sans_effet">µ</nobr>T)</span>
              </div>
              <div class="modal_list_item_content">
                <span>{{ $tc("message['Mesure']") }} E Max(V/m)</span>
              </div>
              <div  v-if="mesure.typedemande == 6" class="modal_list_item_content">
                <span>{{ $tc("message['Mesure']") }} H Max(<nobr class="sans_effet">µ</nobr>T)</span>
              </div>
              <div class="modal_list_item_content">
                <span>{{ $t("message['Valeurs limites (niveau de référence)']") }}</span>
              </div>
            </div>
            <div class="modal_list_item" v-for="(service, index) in mesure.services" :key="index">
              <div class="modal_list_item_content">
                <p>{{service.libelle}}</p>
              </div>
              <div class="modal_list_item_content">
                <p>{{service.bande}} </p>
              </div>
              <div class="modal_list_item_content">
                <p>{{service.champmoyenelectrique}}<span v-if="service.champmoyenelectrique === '' ">N/A</span></p>
              </div>
              <div v-if="mesure.typedemande == 6" class="modal_list_item_content">
                <p>{{service.champmoyenmagnetique}}<span v-if="service.champmoyenmagnetique === '' ">N/A</span></p>
              </div>
              <div class="modal_list_item_content">
                <p>{{service.champmaxelectrique}}<span v-if="service.champmaxelectrique === '' ">N/A</span></p>
              </div>
              <div v-if="mesure.typedemande == 6" class="modal_list_item_content">
                <p>{{service.champmaxmagnetique}} <span v-if="service.champmaxmagnetique === '' ">N/A</span> </p>
              </div>
              <div class="modal_list_item_content">
                <p>{{service.limite}}</p>
              </div>
            </div>
          </div>
          <div class="conditions_subtitle">
            <p v-if="mesure.typedemande != 5 && mesure.typedemande != 6">{{ $t("message['Rappel : la valeur limite la plus faible fixée par le décret du 3 mai 2002 est 28 V/m']") }}.</p>
            <p v-else>{{ $t("message['Note : N/A sera indiqué dans le tableau en cas d absence d un nombre d émissions suffisant']") }}.</p>
          </div>
          <div v-if="mesure.typedemande == 2 || mesure.typedemande == 3 ">
            <div v-if="mesure.typedemande == 2">
              <div class="modal_subtitle">
                <p>{{ $t("message['Résultat de l évaluation de l exposition pour certains services (annexe 2 du protocole)']") }}</p>
              </div>
              <div class="conditions_subtitle">
                <p>{{ $t("message['Conformément au souhait du demandeur, une évaluation informative de l exposition a été réalisée pour certains services. Aucun de ces résultats n a donné lieu à un calcul d extrapolation. Seuls les résultats supérieurs à [0,05] V/m sont mentionnés']") }}.</p>
              </div>
            </div>
            <div v-if="mesure.typedemande == 3">
              <div class="modal_subtitle">
                <p>{{ $t("message['Résultat de l évaluation détaillée de l exposition (cas B du protocole)']") }}</p>
              </div>
              <div class="conditions_subtitle">
                <p>{{ $t("message['Conformément au souhait du demandeur, une évaluation détaillée de l exposition par fréquence a été réalisée. Le résultat de ces mesures détaillées est présenté agrégé par service (colonne mesure), suivi, le cas échéant, du résultat d un calcul d extrapolation. Seuls les résultats supérieurs à [0,05] V/m sont mentionnés']") }}.</p>
              </div>
            </div>
            <div class="modal_list_tab">
              <div class="modal_list_item">
                <div class="modal_list_item_content">
                  <span>Service</span>
                </div>
                <div class="modal_list_item_content">
                  <span>{{ $tc("message['Bande de fréquence']")}}(Mhz)</span>
                </div>
                <div class="modal_list_item_content">
                  <span>{{ $tc("message['Mesure']")}}</span>
                </div>
                <div v-if="mesure.typedemande == 3" class="modal_list_item_content">
                  <span>Extrapolation</span>
                </div>
                <div class="modal_list_item_content">
                  <span>{{ $t("message['Valeur limite (niveau de référence)']") }}</span>
                </div>
              </div>
              <div class="modal_list_item" v-for="(service, index) in services" :key="index">
                <div class="modal_list_item_content">
                  <p>{{service.libelle}}</p>
                </div>
                <div class="modal_list_item_content">
                  <p>{{service.bande}}</p>
                </div>
                <div class="modal_list_item_content">
                  <p v-if="service.mesure">{{service.mesure}} V/m</p>
                  <p v-else>{{service.mesure}}</p>
                </div>
                <div v-if="mesure.typedemande == 3" class="modal_list_item_content">
                  <p v-if="service.extrapolation">{{service.extrapolation}} V/m</p>
                  <p v-else>{{service.extrapolation}}</p>
                </div>
                <div class="modal_list_item_content">
                  <p>{{service.limite}}</p>
                </div>
              </div>
            </div>
            <p class="modal_subtitle">{{ $t("message['Répartition du champ par service']") }}</p>
            <div class="html2pdf__page-break"></div>
            <mesure-vert-bar-chart :chart-data="services" title=""></mesure-vert-bar-chart>
          </div>
          <div class="conditions_subtitle">{{ $t("message['Télécharger le']") }} <a target="blank" :href="'/cartoradio/web/rapports/'+mesure.rapport">{{ $t("message['détail des mesures']") }}</a></div>
          <div class="conditions">
            <p class="conditions_title">Edition {{ $t("message['du']")}} {{date}}</p>
            <p class="conditions_subtitle">{{ $t("message['Pour une meilleure compréhension de cette fiche, consultez le']")}}
              <a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a> {{ $t("message['et la']")}}
              <a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a>.
              <br />
              <span v-if="$root.$i18n.locale === 'en'">In case of error, please.<a href="http://faq.anfr.fr/" target="_blank" class="link"> contact us</a></span>
              <span v-else><a href="http://faq.anfr.fr/" target="_blank" class="link">Nous contacter</a> en cas d'erreur </span></p>
              <p v-if ="mesure.typedemande != 6" class="conditions_text">{{ $t("message['Ces informations relatives etc.']")}}.</p>
              <p v-if ="mesure.typedemande == 6" class="conditions_text">{{ $t("message['Les informations relatives aux.']")}}.</p>
              <p v-if ="mesure.typedemande == 5" class="conditions_text">{{ $t("message['Les informations relatives aux.']")}}.</p>
          </div>
        </div>
      </div>
      <!-- MODAL FOOTER -->
      <div class="modal_footer">
        <div class="modal_footer_btn">
          <label @click="print" v-if="printable" class="print_modal"><span>{{ $tc("message['Imprimer / Télécharger']")}}</span></label>
          <label for="modal_trigger" @click="close" class="close_modal"><span>{{ $tc("message['Fermer']")}}</span></label>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

import MesureVertBarChart from './chart/MesureVertBarChart'
import FichePrinter from './print/FichePrinter'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'FicheMesure',
  components: {
    MesureVertBarChart
  },
  data() {
    return {
      mesures: [],
      mesure: [],
      emetteurs: [],
      adresse: {},
      services: [],
      date: new Date().toLocaleDateString(),
      printable: false
    }
  },
  computed: {
    urlFAQ() {
      return this.$store.state.paramUrl.URL_FAQ ? this.$store.state.paramUrl.URL_FAQ : ''
    },
    urlGlossaire() {
      return this.$store.state.paramUrl.URL_GLOSSAIRE ? this.$store.state.paramUrl.URL_GLOSSAIRE : ''
    }
  },
  methods: {
    loadMesures: function(hashes) {
      var hashesLength = hashes.length
      var paramString = ''
      if (hashesLength > 1) {
        paramString = '?numeros[]='
        for (var i = 0; i < hashesLength; i++) {
          if (i === 0) {
            paramString += hashes[i]
          } else {
            paramString += '&numeros[]=' + hashes[i]
          }
        }
        paramString += '&format=json'
      } else {
        paramString += '/' + hashes[0]
      }

      axios.get('/api/v1/mesures' + paramString)
        .then((response) => {
          var orderedMesures = null
          if (hashesLength > 1) {
            orderedMesures = response.data.mesures
          } else {
            orderedMesures = response.data
          }
          orderedMesures = _.sortBy(orderedMesures, function(dateObj) {
            var IsoDateTo = moment(dateObj.date, 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss')
            return IsoDateTo
          })
          this.mesures = _.reverse(orderedMesures)

          var tabMesure = document.getElementById('tab_mesure')
          var modalMesure = document.getElementById('mesure_modal')
          var tabMesures = document.getElementById('tab_mesures')
          var modalMesures = document.getElementById('mesures_modal')
          if (this.mesures.length === 1) {
            this.mesure = this.mesures[0]
            this.adresse = this.mesure.adresse
            this.emetteurs = this.mesure.emetteurs
            this.services = _.sortBy(this.mesure.services, function(service) {
              if (service.bande !== null) {
                var orderedBande = service.bande.split('-')
                return parseFloat(orderedBande[0])
              } else {
                return null
              }
            })
            tabMesure.classList.add('active')
            tabMesure.classList.remove('hidetab')
            modalMesure.classList.add('active')
            this.printable = true
          } else {
            if (tabMesure) {
              tabMesure.classList.remove('active')
              tabMesure.classList.add('hidetab')
            }
            if (modalMesure) {
              modalMesure.classList.remove('active')
            }
            if (tabMesures) {
              tabMesures.classList.add('active')
              tabMesures.classList.remove('hidetab')
              this.printable = true
            }
            if (modalMesures) {
              modalMesures.classList.add('active')
              this.printable = true
            }
          }
        })
    },
    changeModalTabsFromId: function(mesure) {
      axios.get('/api/v1/mesures/' + mesure.numero)
        .then((response) => {
          mesure = response.data.data

          var tabMesures = document.getElementById('tab_mesures')
          var tabMesure = document.getElementById('tab_mesure')
          var modalMesures = document.getElementById('mesures_modal')
          var modalMesure = document.getElementById('mesure_modal')
          this.mesure = mesure
          this.adresse = mesure.adresse
          this.emetteurs = mesure.emetteurs
          this.services = _.sortBy(mesure.services, function(service) {
            if (service.bande != null) {
              var orderedBande = service.bande.split('-')
              return parseFloat(orderedBande[0])
            } else {
              return null
            }
          })
          tabMesures.classList.remove('active')
          modalMesures.classList.remove('active')
          tabMesure.classList.remove('hidetab')
          tabMesure.classList.add('active')
          modalMesure.classList.add('active')
          this.printable = true
        })
    },
    changeModalTabs: function(event) {
      var elt = event.target
      var tabMesures = document.getElementById('tab_mesures')
      var tabMesure = document.getElementById('tab_mesure')
      var modalMesures = document.getElementById('mesures_modal')
      var modalMesure = document.getElementById('mesure_modal')
      if (elt.classList.contains('tab_supports_et_mesures')) {
        tabMesures.classList.add('active')
        modalMesures.classList.add('active')
        tabMesure.classList.remove('active')
        modalMesure.classList.remove('active')
        this.printable = false
      } else if (elt.classList.contains('tab_support')) {
        tabMesures.classList.remove('active')
        modalMesures.classList.remove('active')
        tabMesure.classList.add('active')
        modalMesure.classList.add('active')
        this.printable = true
      }
    },
    close: function() {
      var tabMesures = document.getElementById('tab_mesures')
      var tabMesure = document.getElementById('tab_mesure')
      var modalMesures = document.getElementById('mesures_modal')
      var modalMesure = document.getElementById('mesure_modal')

      if (tabMesures && modalMesures) {
        tabMesures.classList.add('active')
        modalMesures.classList.add('active')
      }
      tabMesure.classList.remove('active')
      tabMesure.classList.add('hidetab')
      modalMesure.classList.remove('active')
      this.mesures = []
      this.mesure = []
      this.printable = false
    },

    print: function() {
      let element = document.getElementById('mesure_modal').parentElement.getElementsByClassName('active')[0]
      new FichePrinter(element).execute(this.mesure.numero)
    }
  }
}
</script>
<style scoped>
.figure {
  float: left;
  width: 30%;
  margin: 0.5em;
  padding: 0.5em;
  text-align: center;
  font-style: italic;
  font-size: 0.7em;
  font-weight: 600;
  text-indent: 0;
}

.scaled {
  width: 100%;
}
.sans_effet{
  text-transform: lowercase;
}
</style>
